// extracted by mini-css-extract-plugin
export var accordion = "accordion-module--accordion--8040d";
export var content = "accordion-module--content--9d647";
export var contentBody = "accordion-module--contentBody--47dbe";
export var expanded = "accordion-module--expanded--7064b";
export var header = "accordion-module--header--01c11";
export var item = "accordion-module--item--559fd";